import { Card, Col, Row } from "react-bootstrap";
import { IComplianceInvestigationDetails } from "../../../api/IComplianceInvestigation";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import EpaField2Rows from "../../../leap-components/EpaField2Rows";
import { ComplianceInvestigationIcon } from "../../../leap-components/icons/LeapIcons";

interface ComplianceInvestigationHeaderProps {
  complianceInvestigation: IComplianceInvestigationDetails;
  licenceProfile: ILicenceProfile;
}

const ComplianceInvestigationHeader = ({
  complianceInvestigation,
  licenceProfile,
}: ComplianceInvestigationHeaderProps) => {
  return (
    <Card className="flex-fill w-100">
      <Card.Header></Card.Header>
      <Card.Body className="pt-0">
        <Row>
          <Col className="col-12 col-md-6">
            <table className="no-border" style={{ marginTop: "0.6rem" }}>
              <tbody>
                <tr>
                  <td>
                    <ComplianceInvestigationIcon />
                  </td>
                  <td>
                    <h2>
                      Compliance Investigation:{" "}
                      {complianceInvestigation.reference}
                    </h2>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="d-md-none" style={{ height: "20px" }}></div>
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Reference No."}
              value={complianceInvestigation.reference}
            />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Status"}
              value={complianceInvestigation.status}
            />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Authorisation Version"}
              value={complianceInvestigation.licence_regno}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ComplianceInvestigationHeader;
